import { unref, computed } from 'vue'

/**
 * ユーザーリスト表示項目(屋内状態)の利用
 * @param {MaybeRef.<string>} buildingName ビル名
 * @param {MaybeRef.<string>} buildingShortName ビル短縮名
 * @param {MaybeRef.<string>} levelName フロア名
 * @param {MaybeRef.<string>} levelShortName フロア短縮名
 */
export function useUserStatusAdditionalItemIndoor({
  buildingName,
  buildingShortName,
  levelName,
  levelShortName,
}) {
  /**
   * 表示用ビル名称
   * @type {ComputedRef.<string>}
   */
  const buildingText = computed(() => {
    return unref(buildingShortName) || unref(buildingName) || ''
  })

  /**
   * 表示用フロア名称
   * @type {ComputedRef.<string>}
   */
  const levelText = computed(() => {
    return unref(levelShortName) || unref(levelName) || ''
  })

  /**
   * 屋内状態表示テキスト
   * @type {ComputedRef.<string>}
   */
  const text = computed(() => {
    if (!buildingText.value || !levelText.value) return '-'
    return `${buildingText.value} (${levelText.value})`
  })

  return { text, buildingText, levelText }
}
